export enum OrderDirections {
  Asc = 'asc',
  Desc = 'desc',
}
